var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BC1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 10.75V7.012m0 6.509v.032m4.725 3.114h-9.45c-1.29 0-2.38-.854-2.723-2.02-.146-.499.034-1.018.309-1.46l4.725-8.52c1.107-1.778 3.721-1.778 4.828 0l4.725 8.52c.275.442.455.961.309 1.46a2.832 2.832 0 0 1-2.723 2.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon2);
export default __webpack_public_path__ + "static/media/alert-icon-2.fb4dd71053ae7246a8896e4d1ca06640.svg";
export { ForwardRef as ReactComponent };